export default "__VITE_ASSET__DoXUjc26__"